import * as React from "react";
import { SecondaryHeadingWrap } from "../SecondaryHeadingWrap";
import { SecondaryHeading } from "../SecondaryHeading";
import { HeadingTitle } from "../HeadingTitle";
import { HeadingNamesWrap } from "../HeadingNamesWrap";
export class SecondaryHeadingWrapAmerican extends SecondaryHeadingWrap {
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this */
    constructor(props) {
        super(props);
    }
    renderSubheading() {
        return React.createElement(SecondaryHeading, { componentPrefix: this.props.cardType },
            React.createElement(HeadingTitle, { name: this.props.name, eventsCount: this.props.eventsCount }),
            this.props.marketNames.length
                ? React.createElement(HeadingNamesWrap, { marketNames: this.props.marketNames, marketTemplates: this.props.marketTemplates })
                : "");
    }
}
//# sourceMappingURL=SecondaryHeadingWrapAmerican.js.map